/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import './asset-dashboard-widget.scss';

/* eslint-disable import/no-unresolved, import/default */

import assetDashboardWidgetTemplate from './asset-dashboard-widget.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

export default angular.module('agrolog.client.assetDashboardWidget', [])
    .directive('agAssetDashboardWidget', AssetDashboardWidget)
    .name;

/*@ngInject*/
function AssetDashboardWidget() {
    return {
        restrict: "E",
        scope: true,
        bindToController: {
            ctx: '=',
            asset: '=',
            isSelected: '=',
            multipleSilosConfig: '<'
        },
        controller: AssetDashboardWidgetController,
        controllerAs: 'vm',
        templateUrl: assetDashboardWidgetTemplate
    };
}

/* eslint-disable angular/angularelement */


/*@ngInject*/
function AssetDashboardWidgetController($scope, $rootScope, $filter,  $translate, $log, types, agTypes, agUtils, attributeService) {

    let vm = this;

    vm.agTypes = agTypes;

    vm.sensorsViewIcons = {
        temperature: "ag:thermometer",
        moisture: "ag:moisture",
        co2: "ag:co2_level",
        cropLevel: "ag:crop_level",
        headSpace: "ag:head_space",
        aeration: "ag:aeration",
        aerationAlarm: "ag:aeration_alarm"
    };
    vm.assetTitle = vm.asset ? (vm.asset.label || vm.asset.name) : '';
    vm.selectedViewIcon = vm.sensorsViewIcons.temperature;
    vm.tooltipSensorsView = selectTooltipName(vm.sensorsViewIcons.temperature);

    vm.assetIcon = assetIcon;
    vm.changeSensorsView = changeSensorsView;
    vm.resolveSelectedTelemetryType = resolveSelectedTelemetryType;
    vm.multipleChangeSensorsView = multipleChangeSensorsView;

    resolveCropName();

    vm.hasFanActive = false;
    vm.latestFanValuesSubscriptionOptions = {
        callbacks: {
            onDataUpdated: onFansUpdated,
            onDataUpdateError: onDataUpdateError,
            dataLoading: function() {}
        },
        useDashboardTimewindow: false
    };

    function getValue(keyData) {
        if (keyData && keyData.data && keyData.data[0] && angular.isDefined(keyData.data[0][1])) {
            return keyData.data[0][1];
        } else {
            return '';
        }
    }

    function onFansUpdated(subscription, apply) {
        var data = subscription.data;
        for (var i=0;i<data.length;i++) {
            var datasourceData = data[i];
            var val = getValue(datasourceData);
            switch (datasourceData.dataKey.name) {
                case vm.agTypes.telemetry.aeration.state:
                    vm.hasFanActive = val === 'on';
                    break;
            }
        }

        if (apply) {
            $scope.$digest();
        }
    }

    function onDataUpdateError(subscription, e) {
        $log.error(e);
    }

    $scope.$on('multipleChangeSensorsView', (event, icon) => {
        if (vm.asset.type === agTypes.assetType.silo) {
            if (icon === vm.sensorsViewIcons.temperature || (icon === vm.sensorsViewIcons.moisture && vm.asset.hasMoistureCables) || (icon === vm.sensorsViewIcons.co2 && vm.asset.hasCO2Cables) ||
                (icon === vm.sensorsViewIcons.cropLevel) || (icon === vm.sensorsViewIcons.headSpace && vm.asset.hasHeadSpaceSensor)
                || (icon === vm.sensorsViewIcons.aeration && vm.asset.hasConnectedSystems)
                || (icon === vm.sensorsViewIcons.aerationAlarm && vm.asset.hasConnectedSystems)) {
                changeSensorsView(icon);
            } else {
                changeSensorsView(vm.sensorsViewIcons.temperature);
            }
        }
    });

    initFansSubscriptions();

    function assetIcon() {
        if (vm.asset) {
            return (vm.asset.type === agTypes.assetType.aeration && vm.asset.aerationType)
                ? agUtils.getAssetIcon(vm.asset.aerationType, vm.asset.highestAlarmSeverity, vm.asset.highestAlarmStatus)
                : agUtils.getAssetIcon(vm.asset.type, vm.asset.highestAlarmSeverity, vm.asset.highestAlarmStatus);
        } else {
            return '';
        }
    }

    function changeSensorsView(icon, event) {
        if (event) {
            event.stopPropagation();
        }

        vm.selectedViewIcon = icon;
        vm.tooltipSensorsView = selectTooltipName(icon);
    }

    function resolveSelectedTelemetryType() {
        if (vm.selectedViewIcon === vm.sensorsViewIcons.temperature) {
            return agTypes.telemetry.type.temperature;
        } else if (vm.selectedViewIcon === vm.sensorsViewIcons.moisture) {
            return agTypes.telemetry.type.moisture;
        } else if (vm.selectedViewIcon === vm.sensorsViewIcons.co2) {
            return agTypes.telemetry.type.co2;
        }

        return null;
    }

    function selectTooltipName(icon) {
        let res;
        if (icon === vm.sensorsViewIcons.temperature) {
            res = "ag.silo.temperature-view";
        } else if (icon === vm.sensorsViewIcons.moisture) {
            res = "ag.silo.moisture-view";
        } else if (icon === vm.sensorsViewIcons.co2) {
            res = "ag.silo.co2-view";
        } else if (icon === vm.sensorsViewIcons.cropLevel) {
            res = "ag.silo.crop-level-view";
        } else if (icon === vm.sensorsViewIcons.headSpace) {
            res = "ag.silo.head-space-view";
        } else if (icon === vm.sensorsViewIcons.aeration) {
            res = "ag.overview.aerations-title";
        } else if (icon === vm.sensorsViewIcons.aerationAlarm) {
            res = "ag.overview.aerations-title";
        }
        return res;
    }

    function multipleChangeSensorsView(icon) {
        $rootScope.$broadcast("multipleChangeSensorsView", icon);
    }

    function resolveCropName() {
        agUtils.getCropNames().then(
            (response) => {
                vm.cropNames = [];
                var cropNames = response.jsonValue;
                for (var property in cropNames) {
                    var cropNameObj = {};
                    cropNameObj.nameId = property;
                    cropNameObj.value = cropNames[property];
                    vm.cropNames.push(cropNameObj);
                }

                resolveCropType();
            }
        );
    }

    function resolveCropType() {
        vm.cropLabel = null;
        vm.assetTitle = (vm.asset.label || vm.asset.name);
        if (vm.asset.type === agTypes.assetType.silo) {
            const siloId = vm.asset.id;
            attributeService.getEntityLatestTimeseriesValues(siloId.entityType, siloId.id, [agTypes.telemetry.silo.cropType], { ignoreLoading: true }).then(
                (cropResponse) => {
                    const cropType = cropResponse.crop_type[0].value;
                    if (vm.cropNames) {
                        var currentCropName = $filter('filter')(vm.cropNames, {nameId: cropType}, true);
                        if (currentCropName && currentCropName.length) {
                            vm.cropType = currentCropName[0];
                        }
                        if (vm.cropType) {
                            vm.assetTitle = `${(vm.asset.label || vm.asset.name)} - ${$translate.instant(agTypes.cropNames[vm.cropType.value.name])}`;
                        }
                    }
                }
            );
        }
    }

    function initFansSubscriptions() {
        reset();

        if (vm.asset && vm.asset.connectedSystems) {
            const aerations = vm.asset.connectedSystems ?? [];
            const latestValuesSubscriptionsInfo = [];
            for (let aerationIndex in aerations) {
                const aeration = aerations[aerationIndex];

                if (aeration.aerationType === agTypes.aerationType.aeration) {
                    latestValuesSubscriptionsInfo.push({
                        type: types.datasourceType.entity,
                        entityType: types.entityType.asset,
                        entityId: aeration.id.id,
                        entityName: aeration.name,
                        timeseries: [
                            {name: vm.agTypes.telemetry.aeration.state}
                        ]
                    });
                }
            }

            if (latestValuesSubscriptionsInfo.length > 0) {
                vm.ctx.subscriptionApi.createSubscriptionFromInfo(
                    types.widgetType.latest.value, latestValuesSubscriptionsInfo, vm.latestFanValuesSubscriptionOptions, false, true).then(
                    function (subscription) {
                        vm.latestValuesSubscription = subscription;
                    }
                );
            }
        }
    }

    function reset() {
        if (vm.latestValuesSubscription) {
            vm.ctx.subscriptionApi.removeSubscription(vm.latestValuesSubscription.id);
        }
    }
}
